export const toOxford = (list, conjunction) => {
  if(list.length === 1) return list[0]
  if(list.length === 2) return list.join(` ${conjunction} `)
  return list.slice(0, -1).join(', ') + `, ${conjunction} ${list[list.length-1]}`
}